import useSWR from "swr";

import * as fetcher from "../fetcher";
import { type WidgetData } from "./types";

export const useWidgetPreferences = () => {
  return useSWR<WidgetData[]>(
    `/coworkers/widgetpreferences`,
    async (url: string) => {
      const data = await fetcher.core.get<WidgetData[]>(url);
      return data;

      // TODO: Refactor;
      // TODO: Remove this after all users have been migrated
      // const convertedData = convertFromOldWidgetPosToNew(data);
      // if (convertedData) {
      //   await Promise.all(
      //     convertedData.map((widget) => {
      //       return updateWidgetPreferences(widget, true);
      //     })
      //   );
      // }
      // return convertedData ?? data;
    },
    { shouldRetryOnError: false, revalidateOnFocus: false }
  );
};
